/**
 * Identificação do add-in nas chamadas à API do Cognito.
 *
 * O add-in usa os MESMOS endpoints REST que o frontend web, então sem estes headers o
 * tráfego dele fica indistinguível no SigNoz. O backend lê `X-Cognito-Client` e grava nos
 * spans como `cognito.client` (ver `OtelClientAttributes` no Vault-Backend), o que permite
 * filtrar latência, erro e volume só do Excel.
 *
 * Todo caminho HTTP novo do add-in deve mandar estes headers — hoje são dois:
 * `src/shared/api-client.ts` e `src/libs/cognito-api/mutator.ts`.
 */

/** Valor de `X-Cognito-Client` — precisa casar com o que os filtros/dashboards do SigNoz usam. */
export const COGNITO_CLIENT_ID = "excel-addin";

// `require` em vez de import: o webpack resolve o JSON em build time e evita depender de
// `resolveJsonModule` no tsconfig.
// eslint-disable-next-line @typescript-eslint/no-var-requires
const packageVersion: string = (require("../../package.json") as { version?: string }).version ?? "0.0.0";

/** Headers de identificação a serem mesclados em toda chamada à API. */
export const COGNITO_CLIENT_HEADERS: Readonly<Record<string, string>> = Object.freeze({
  "X-Cognito-Client": COGNITO_CLIENT_ID,
  "X-Cognito-Client-Version": packageVersion,
});
